import { useState } from 'react';

import { TABLE_TYPE } from 'types';
import { IResponsiveTableRowSelection } from 'views/components/UI/ResponsiveTable';

function useSelectedRowKeys(
  tableType: TABLE_TYPE,
  initialValueSelected: [] | number[],
): IResponsiveTableRowSelection {
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>(initialValueSelected);

  const onSelectChange = (selectedRowKey: number[]): void => {
    setSelectedRowKeys(selectedRowKey);
  };

  const clearSelection = (): void => {
    setSelectedRowKeys([]);
  };

  const rowSelection = {
    type: tableType,
    selectedRowsKeys: selectedRowKeys,
    onChange: onSelectChange,
    clearSelection,
  };

  return rowSelection;
}
export { useSelectedRowKeys };
